const FILTERS = {
  hspp: {
    hspp_version: {
      title: "HSPP Version",
      icon: "server.png",
    },

    hspc_version: {
      title: "HSPC Version",
      icon: "server.png",
    },
    operating_system: {
      title: "Operating System",
      icon: "os.png",
    },
    container_orchestrator: {
      title: "Container Orchestrator",
      icon: "os.png",
    },

    orchestrator_version: {
      title: "Orchestrator Version",
      icon: "os.png",
    },
    array_customer_version: {
      title: "Storage",
      icon: "array.png",
    },
    notes: {
      title: "Notes",
      icon: "array.png",
    },
    report_name: {
      title: "Report Name",
      icon: "multipath.png",
    },
  },
};

export default FILTERS;
